export default "__VITE_ASSET__9e85f481__"